import http from "./httpService";
import { apiUrl } from "../config.json";

const apiEndpoint = apiUrl + "/issues";

function supportUrl(uri) {
	return `${apiEndpoint}/${uri}`;
}

export function getIssue(id) {
	return http.get(supportUrl(id));
}

export function getIssues(currentPage, pageSize, orderby) {
	const params =
		"currentPage=" +
		currentPage +
		"&pageSize=" +
		pageSize +
		"&orderby=" +
		orderby;
	const url = "?" + params;
	const issues = http.get(supportUrl(url));

	return issues;
}

export function saveIssue(issue) {
	return http.post(apiEndpoint, issue);
}
